import React from 'react'; // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom';
import { sessionStorage } from 'dibs-browser-storage';

const AUTO_MODAL_SHOWN = 'autoModalShown';
const MODAL_SHOW_DELAY = 2000;

export const loadAutoModal = ({ AutoModal, modalProps }) => {
    if (AutoModal) {
        setTimeout(() => {
            const div = document.createElement('div');
            document.body.appendChild(div);
            ReactDOM.render(<AutoModal {...modalProps} />, div);
        }, MODAL_SHOW_DELAY);
    }
};

export const setModalShown = () => {
    sessionStorage.setItem(AUTO_MODAL_SHOWN, true);
};

export const wasModalShown = () =>
    sessionStorage.getItem(AUTO_MODAL_SHOWN) || sessionStorage.getItem('authModalShown');



// WEBPACK FOOTER //
// ./src/abandonedCheckout/autoModalHelper.jsx